export const CARE_CARD_SLOT_KEY = 'care-card';
export const LIFE_INSURANCE_QUOTE_CARD_SLOT_KEY = 'life-insurance-quote-card';

export const TYP_RECOMMENDATION_CARD_SLOT_KEYS = [
  CARE_CARD_SLOT_KEY,
  LIFE_INSURANCE_QUOTE_CARD_SLOT_KEY,
] as const;
